// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "./node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "./node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Absolute Center Spinner */
.loading {
  position: fixed;
  z-index: 99999;
  height: 2em;
  width: 2em;
  overflow: show;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

/* Transparent Overlay */
.loading:before {
  content: "";
  display: block;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));

  background: -webkit-radial-gradient(
    rgba(20, 20, 20, 0.8),
    rgba(0, 0, 0, 0.8)
  );
}

/* :not(:required) hides these rules from IE9 and below */
.loading:not(:required) {
  /* hide "loading..." text */
  font: 0/0;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.loading:not(:required):after {
  content: "";
  display: block;
  font-size: 10px;
  width: 1em;
  height: 1em;
  margin-top: -0.5em;
  -webkit-animation: spinner 150ms infinite linear;
  -moz-animation: spinner 150ms infinite linear;
  -ms-animation: spinner 150ms infinite linear;
  -o-animation: spinner 150ms infinite linear;
  animation: spinner 150ms infinite linear;
  border-radius: 0.5em;
  -webkit-box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
  box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,
    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,
    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,
    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,
    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,
    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;
}

/* Animation */

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-moz-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@-o-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -ms-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
/* 
  input[type="radio"] {
    opacity: 0.011;
    z-index: 100;
    border: 3px solid #fff;
  }
   */
input[type="radio"]:checked + label {
  background: #ff528f;
  border-radius: 4px;
  min-width: 145px;
  height: 55px;
  transition: 0.25s;
  /* font-family: 'Inter'; */
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 22px;
  color: #fff;
  margin: auto;
  padding: 1rem;
}

.modal-backdrop
{
    --bs-backdrop-bg: rgba(255, 255,255,0.3 ) !important;
}

.custom-modal .modal-content {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
}


.response-card {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 16px;
  margin: 16px 0;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.question-text {
  font-size: 20px; /* Slightly larger for emphasis */
  font-weight: bold;
  margin-bottom: 12px;
  color: #333; /* Darker text for contrast */
}

.answer-container {
  display: flex;
  align-items: flex-start; /* Aligns text and image at the top */
  margin-top: 8px;
}

.answer-text {
  font-size: 16px; /* Standard size for readability */
  color: #555;
  line-height: 1.5; /* Improves text spacing */
  display: flex; /* Ensures the image and text stay aligned */
  align-items: center; /* Centers image with the text vertically */
}

.response-image {
  width: 25px; /* Adjust size for consistency */
  height: 25px;
  object-fit: cover;
  border-radius: 8px; /* Slightly rounded corners */
  margin-right: 12px; /* Adds spacing between image and text */
}
`, "",{"version":3,"sources":["webpack://./App.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,eAAe;EACf,cAAc;EACd,WAAW;EACX,UAAU;EACV,cAAc;EACd,YAAY;EACZ,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,sEAAsE;;EAEtE;;;GAGC;AACH;;AAEA,yDAAyD;AACzD;EACE,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gDAAgD;EAChD,6CAA6C;EAC7C,4CAA4C;EAC5C,2CAA2C;EAC3C,wCAAwC;EACxC,oBAAoB;EACpB;;;;;;;8CAO4C;EAC5C;;;;;;;8CAO4C;AAC9C;;AAEA,cAAc;;AAEd;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,4BAA4B;IAC5B,2BAA2B;IAC3B,0BAA0B;IAC1B,uBAAuB;EACzB;EACA;IACE,iCAAiC;IACjC,8BAA8B;IAC9B,6BAA6B;IAC7B,4BAA4B;IAC5B,yBAAyB;EAC3B;AACF;AACA;;;;;;IAMI;AACJ;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;IAEI,oDAAoD;AACxD;;AAEA;EACE,wCAAwC;AAC1C;;;AAGA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,eAAe,EAAE,iCAAiC;EAClD,iBAAiB;EACjB,mBAAmB;EACnB,WAAW,EAAE,6BAA6B;AAC5C;;AAEA;EACE,aAAa;EACb,uBAAuB,EAAE,qCAAqC;EAC9D,eAAe;AACjB;;AAEA;EACE,eAAe,EAAE,kCAAkC;EACnD,WAAW;EACX,gBAAgB,EAAE,0BAA0B;EAC5C,aAAa,EAAE,4CAA4C;EAC3D,mBAAmB,EAAE,2CAA2C;AAClE;;AAEA;EACE,WAAW,EAAE,gCAAgC;EAC7C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB,EAAE,6BAA6B;EACjD,kBAAkB,EAAE,wCAAwC;AAC9D","sourcesContent":["/* Absolute Center Spinner */\n.loading {\n  position: fixed;\n  z-index: 99999;\n  height: 2em;\n  width: 2em;\n  overflow: show;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n/* Transparent Overlay */\n.loading:before {\n  content: \"\";\n  display: block;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: radial-gradient(rgba(20, 20, 20, 0.8), rgba(0, 0, 0, 0.8));\n\n  background: -webkit-radial-gradient(\n    rgba(20, 20, 20, 0.8),\n    rgba(0, 0, 0, 0.8)\n  );\n}\n\n/* :not(:required) hides these rules from IE9 and below */\n.loading:not(:required) {\n  /* hide \"loading...\" text */\n  font: 0/0;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.loading:not(:required):after {\n  content: \"\";\n  display: block;\n  font-size: 10px;\n  width: 1em;\n  height: 1em;\n  margin-top: -0.5em;\n  -webkit-animation: spinner 150ms infinite linear;\n  -moz-animation: spinner 150ms infinite linear;\n  -ms-animation: spinner 150ms infinite linear;\n  -o-animation: spinner 150ms infinite linear;\n  animation: spinner 150ms infinite linear;\n  border-radius: 0.5em;\n  -webkit-box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,\n    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,\n    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,\n    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,\n    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,\n    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,\n    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,\n    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;\n  box-shadow: rgba(255, 255, 255, 0.75) 1.5em 0 0 0,\n    rgba(255, 255, 255, 0.75) 1.1em 1.1em 0 0,\n    rgba(255, 255, 255, 0.75) 0 1.5em 0 0,\n    rgba(255, 255, 255, 0.75) -1.1em 1.1em 0 0,\n    rgba(255, 255, 255, 0.75) -1.5em 0 0 0,\n    rgba(255, 255, 255, 0.75) -1.1em -1.1em 0 0,\n    rgba(255, 255, 255, 0.75) 0 -1.5em 0 0,\n    rgba(255, 255, 255, 0.75) 1.1em -1.1em 0 0;\n}\n\n/* Animation */\n\n@-webkit-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-moz-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-o-keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@keyframes spinner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/* \n  input[type=\"radio\"] {\n    opacity: 0.011;\n    z-index: 100;\n    border: 3px solid #fff;\n  }\n   */\ninput[type=\"radio\"]:checked + label {\n  background: #ff528f;\n  border-radius: 4px;\n  min-width: 145px;\n  height: 55px;\n  transition: 0.25s;\n  /* font-family: 'Inter'; */\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 22px;\n  color: #fff;\n  margin: auto;\n  padding: 1rem;\n}\n\n.modal-backdrop\n{\n    --bs-backdrop-bg: rgba(255, 255,255,0.3 ) !important;\n}\n\n.custom-modal .modal-content {\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);\n}\n\n\n.response-card {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 16px 0;\n  background-color: #f9f9f9;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.question-text {\n  font-size: 20px; /* Slightly larger for emphasis */\n  font-weight: bold;\n  margin-bottom: 12px;\n  color: #333; /* Darker text for contrast */\n}\n\n.answer-container {\n  display: flex;\n  align-items: flex-start; /* Aligns text and image at the top */\n  margin-top: 8px;\n}\n\n.answer-text {\n  font-size: 16px; /* Standard size for readability */\n  color: #555;\n  line-height: 1.5; /* Improves text spacing */\n  display: flex; /* Ensures the image and text stay aligned */\n  align-items: center; /* Centers image with the text vertically */\n}\n\n.response-image {\n  width: 25px; /* Adjust size for consistency */\n  height: 25px;\n  object-fit: cover;\n  border-radius: 8px; /* Slightly rounded corners */\n  margin-right: 12px; /* Adds spacing between image and text */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
